import React from 'react';
import { DefaultIconContainer } from './style';

interface DefaultIcon {
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
    icon?: JSX.Element;
}

function DefaultIcon({ onClick, icon }: DefaultIcon): JSX.Element {
    return <DefaultIconContainer onClick={onClick}>{icon}</DefaultIconContainer>;
}

export default DefaultIcon;
